module.exports = __webpack_public_path__ + "static/assets/be103bce96f084e2f7fa74fe5a8b157c.svg";